import activateLicense from "@api/operations/activate-license";
import Router from "next/router";
import React, { useContext, useState } from "react";

import Button from "@components/Button";
import LicenseActivationForm from "@components/LicenseActivationForm";
import Title from "@components/Title";
import UserContext from "@components/UserContext";

const Activate = () => {
  const { customer } = useContext(UserContext);

  return <></>;
};

export default Activate;
